import { REGISTRATION_TAB } from '@constants/registration';
import { jurisdictionsRoutes } from '@routes';

/**
 * @typedef {Object} entityDetailApiItem
 * @property {string} id Entity ID
 * @property {string} account Owner account ID
 * @property {string} address Address
 * @property {string} city City
 * @property {string} colour Display colour
 * @property {string} country Country ID
 * @property {string} industryType Industry type
 * @property {string} internalRef
 * @property {boolean} managed Is it a managed account
 * @property {string} name Entity name
 * @property {string} taxNumber Account tax number
 * @property {string} zipCode Account zip code
 */

/**
 * @typedef {Object} entityJurisdictionApiItem
 * @property {string} id Jurisdiction ID
 * @property {string} entity Entity ID
 * @property {number} activeRegistrationCount Number of active registrations
 * @property {number} deletedRegistrationCount Number of deleted registrations
 * @property {number} deregisteredRegistrationCount Number of inactive registrations
 * @property {boolean} hasClientTransactionTypes Custom transaction types exist for this entity jurisdiction
 * @property {string} taxableJurisdiction Taxable jurisdiction ID
 * @property {jurisdictionApiItem} taxableJurisdictionDetail Jurisdiction detail
 * @property {entityDetailApiItem} entityDetail Entity detail
 */

/**
 * @typedef {Object} entityJurisdictionItem
 * @property {string} id Jurisdiction ID
 * @property {string} entityId Entity ID
 * @property {string} entityName Entity name
 * @property {string} name Jurisdiction name
 * @property {string} iso Jurisdiction ISO code
 * @property {string} to URL for detail page
 * @property {string} countryId id of associated country
 * @property {number} activeRegistrationsCount Number of active registrations
 * @property {number} inactiveRegistrationsCount Number of inactive registrations
 */

/**
 * Transform single entity jurisdiction from API data
 * @param {entityJurisdictionApiItem} jurisdictionData Jurisdiction data from the API
 * @returns {entityJurisdictionItem} Transformed jurisdiction data
 */
export const entityJurisdictionItemModel = entityJurisdictionItem => {
  const {
    id,
    entity: entityId,
    activeRegistrationCount: activeRegistrationsCount,
  } = entityJurisdictionItem;

  return {
    id,
    entityId,
    activeRegistrationsCount,
    inactiveRegistrationsCount: entityJurisdictionItem.deregisteredRegistrationCount,
    name: entityJurisdictionItem.taxableJurisdictionDetail.name,
    entityName: entityJurisdictionItem.entityDetail.name,
    iso: entityJurisdictionItem.taxableJurisdictionDetail.countryDetail.iso,
    countryId: entityJurisdictionItem.taxableJurisdictionDetail.countryDetail.id,
    to: jurisdictionsRoutes.DETAIL.make({
      entityId,
      entityJurisdictionId: id,
      tab: activeRegistrationsCount ? REGISTRATION_TAB.ACTIVE : REGISTRATION_TAB.INACTIVE,
    }),
  };
};
